import * as React from 'react';
import { useSelector } from 'react-redux';

import { CommercialDiscountRow } from '../CommercialDiscountRow';
import {
  selectActivePeriod,
  selectActivePlacingType,
  selectHighDemandCoefficient,
} from '../../../../selectors/publishTerms';
import { formatMoney } from '../../../../utils/string';
import { EPlacingType } from '../../../../redux/reducers';
import { selectIsCommercial } from '../../../../selectors/offer';

export const CommercialDiscountContainer = () => {
  const isCommercial = useSelector(selectIsCommercial);
  const hasDifferentialPrices = !!useSelector(selectHighDemandCoefficient);
  const selectedPlacingType = useSelector(selectActivePlacingType);
  const isBalancePlacingType = selectedPlacingType === EPlacingType.balance;
  const activePeriod = useSelector(selectActivePeriod);

  if (!isCommercial || !hasDifferentialPrices || !isBalancePlacingType || !activePeriod) {
    return null;
  }

  const { marketingPrice, price, discount } = activePeriod;

  if (discount === 0 || marketingPrice === price) {
    return null;
  }

  const formattedDiscountName = `Скидка ${discount}%`;
  const discountAbsolute = marketingPrice - price;
  const discountValue = `-${formatMoney(discountAbsolute)}`;

  return <CommercialDiscountRow name={formattedDiscountName} value={discountValue} />;
};
